export default __webpack_public_path__ + "static/media/null.a28e1cdc.svg";